


































import { Component, Vue } from "vue-property-decorator";
import AdminSidebarComponent from "@/app/admin/components/adminSidebar/adminSidebar.component.vue";
import ManageSpaceComponent from "@/app/components/manageSpace/manageSpace.component.vue";
import NewSpaceComponent from "@/app/admin/components/newSpace/newSpace.component.vue";
@Component({
  components: {
    NewSpaceComponent,
    AdminSidebarComponent,
    ManageSpaceComponent,
  },
})
export default class AdminView extends Vue {
  get sectionName(): string {
    return this.$route.name;
  }
  get backTo(): boolean {
    switch (this.$route.name) {
      case "users_list": {
        return true;
      }
      case "new_space": {
        return true;
      }
      case "spaces": {
        return true;
      }
      default:
        return false;
    }
  }
  get params() {
    return this.$route.params;
  }
  get activeManageSpace(): boolean {
    return this.$store.getters["FloatMenuStore/getManageSpace"];
  }
  mounted(): void {
    this.$store.dispatch("UserStore/getUserAction", {
      callback: () => {
        // do nothing
      },
    });
  }
  goBack(): void {
    this.$router.go(-1);
  }
  openCreateSpaceModal(): void {
    this.$router.push({ name: "new_space" });
    //this.$store.dispatch("AdminStore/setOpenNewSpaceModalAction", true);
  }
}
